// extracted by mini-css-extract-plugin
module.exports = {"documentInformationContainer":"_a79e74f","uploadingYourDocumentText":"_21ea15a","uploadButton":"_a2062be","idscanUploadButton":"_639ba2b"};